import { BackendSearch } from '@shared/datastore/core';
import { SearchKeywordProjectsResultAjax } from './search-keyword-projects.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchKeywordProjects: SearchKeywordProjectsResultAjax;
  }
}

export const searchKeywordProjectsBackend: BackendSearch = {
  fetch: q => ({
    endpoint: `search/keywordProjects.php`,
    isGaf: true,
    params: q,
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-keyword-projects/search-keyword-projects.backend.ts